import React, { Component } from 'react'
import { connect } from 'react-redux'

import { DistribucionPorCerealView } from '../components/DistribucionPorCerealView'

class DistribucionPorCereal extends Component {
  render () {
    return <DistribucionPorCerealView />
  }
}

const withRedux = connect(null, null)

export default withRedux(DistribucionPorCereal)
